import React from "react";
import Svg, { Path, Defs, Circle, Rect, G, ClipPath } from "react-native-svg";

export default function CommentUnreadIcon({ width = 20, height = 20 }) {
  const pathId = "paint0_linear_comment_icon" + Math.random();
  const pathUrl = "url(#" + pathId + ")";

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath={pathUrl}>
        <Path
          d="M21.1662 5.33301H13.4473C13.7589 6.52775 13.7319 7.78564 13.3694 8.96594C13.0069 10.1462 12.3231 11.2024 11.3946 12.0162C10.4661 12.8301 9.32943 13.3696 8.1118 13.5743C6.89417 13.7789 5.6436 13.6408 4.5 13.1753V21.1659C4.4999 21.3243 4.54496 21.4795 4.62989 21.6132C4.71482 21.7469 4.8361 21.8537 4.97953 21.9209C5.12296 21.9882 5.28258 22.0132 5.4397 21.9929C5.59682 21.9727 5.74491 21.9081 5.86663 21.8067L10.6348 17.8327H21.1662C21.3872 17.8327 21.5992 17.7449 21.7555 17.5886C21.9118 17.4323 21.9995 17.2204 21.9995 16.9994V6.16632C21.9995 5.94531 21.9118 5.73336 21.7555 5.57708C21.5992 5.4208 21.3872 5.33301 21.1662 5.33301V5.33301Z"
          fill="#DADADA"
        />
        <Circle cx="7" cy="7" r="5" fill="#DD5F43" />
      </G>
      <Defs>
        <ClipPath id={pathId}>
          <Rect width="24" height="24" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
